const DEVICE_KEY = 'patience-fingerprint.v1.deviceKey';
const LOCAL_RESULTS = 'patience-fingerprint.v1.unsentResults';

export function getOrCreateDeviceKey(): string {
  const existing = localStorage.getItem(DEVICE_KEY);
  if (existing) return existing;
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  const key = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  localStorage.setItem(DEVICE_KEY, key);
  return key;
}

export function rememberUnsent(payload: unknown) {
  localStorage.setItem(LOCAL_RESULTS, JSON.stringify({ savedAt: new Date().toISOString(), payload }));
}

export function clearUnsent() {
  localStorage.removeItem(LOCAL_RESULTS);
}

export function hasUnsent() {
  return Boolean(localStorage.getItem(LOCAL_RESULTS));
}
